<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="mb-5" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect placeholder="Select"
                        v-model="relay.user"
                        :multiple="false"
                        :options="userList"
                        :load-options="loadUserList"
                        value-format="object"
            />
        </div>
        <div class="mb-4">
            <label>Relay Group:</label>
            <treeselect placeholder="Select Group"
                        v-model="relay.group"
                        :multiple="false"
                        :options="groupList"
                        :load-options="loadGroupList"
                        value-format="object"
            />
            <div class="text-danger" v-if="$v.relay.group.$error">Relay Group is required</div>
        </div>
        <div class="mb-4">
            <label>SMTP Server:</label>
            <treeselect placeholder="Select SMTP Server"
                        v-model="relay.smtpServer"
                        :multiple="false"
                        :options="serverList"
                        :load-options="loadServerList"
                        value-format="object"
            />
            <div class="text-danger" v-if="$v.relay.smtpServer.$error">SMTP Server is required</div>
        </div>
        <div class="mb-4" v-if="id">
            <label>Socks Proxy:</label>
            <treeselect placeholder="Select Socks Proxy"
                        v-model="relay.socks"
                        :multiple="false"
                        :options="socksList"
                        :load-options="loadSocksList"
                        value-format="object"
            />
        </div>
        <div class="form-group">
            <label class="mb-1">Sender Email:</label>
            <input v-model="relay.senderEmail" type="text" class="form-control">
            <div v-if="$v.relay.senderEmail.$error">
                <div class="text-danger" v-if="$v.relay.senderEmail.required">Email is required</div>
                <div class="text-danger" v-if="$v.relay.senderEmail.email">Invalid Email</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Account(login):</label>
            <input v-model="relay.account" type="text" class="form-control">
            <div class="text-danger" v-if="$v.relay.account.$error">Account is required</div>
        </div>
        <div class="form-group">
            <label class="mb-1">Password:</label>
            <input v-model="relay.password" type="text" class="form-control">
            <div v-if="$v.relay.password.$error">
                <div class="text-danger" v-if="!$v.relay.account.required">Password is required</div>
            </div>
        </div>
        <div class="form-group">
            <label class="custom-control custom-checkbox m-b-0">
                <input v-model="relay.active" type="checkbox" class="custom-control-input">
                <span class="custom-control-label">Is Active</span>
            </label>
        </div>
        <div class="form-group" v-if="id">
            <label class="mb-1">Normal Relay speed(seconds between sending):</label>
            <input v-model.number="relay.normalSpeed" type="text" class="form-control">
            <div v-if="$v.relay.normalSpeed.$error">
                <div class="text-danger" v-if="!$v.relay.normalSpeed.required">Normal Relay speed is required</div>
                <div class="text-danger" v-if="!$v.relay.normalSpeed.integer">Normal Relay speed must be integer</div>
            </div>
        </div>
        <div class="form-group" v-if="id">
            <label class="mb-1">Backoff Relay speed(seconds between sending):</label>
            <input v-model.number="relay.backoffSpeed" type="text" class="form-control">
            <div v-if="$v.relay.backoffSpeed.$error">
                <div class="text-danger" v-if="!$v.relay.backoffSpeed.required">Backoff Relay speed is required</div>
                <div class="text-danger" v-if="!$v.relay.backoffSpeed.integer">Backoff Relay speed must be integer</div>
            </div>
        </div>
        <div class="form-group">
            <label class="custom-control custom-checkbox m-b-0">
                <input v-model="relay.backoff" type="checkbox" class="custom-control-input">
                <span class="custom-control-label">Backoff mode</span>
            </label>
        </div>
        <div class="form-group">
            <label class="mb-3">Relay Status</label><br>
            <span class="editable-select">
                <select v-model.number="relay.status">
                    <option v-for="(value, key) in statuses" :key=key v-bind:value="key">{{ value }}</option>
                </select>
            </span>
        </div>
        <div class="form-group">
            <label class="mb-1">Description:</label>
            <input v-model="relay.description" type="text" class="form-control">
            <div v-if="$v.relay.description.$error">
                <div class="text-danger" v-if="$v.relay.description.maxLenght">Max length is 400 symbols</div>
            </div>
        </div>
        <div class="form-group text-center p-b-20  p-t-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required, integer, email, maxLength } from 'vuelidate/lib/validators';
    import Treeselect from '@riophae/vue-treeselect';
    import SmtpRelayService from '../../services/SmtpRelayService';
    import SmtpRelayGroupService from '../../services/SmtpRelayGroupService';
    import SmtpServerService from '../../services/SmtpServerService';
    import SocksProxyService from '../../services/SocksProxyService';
    import UserService from '../../services/UserService';
    import {RelayStatus} from '../../constants';

    export default {
        name: 'SmtpRelayForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                relay: {
                    user: null,
                    group: null,
                    smtpServer: null,
                    socks: null,
                    senderEmail: null,
                    account: null,
                    password: null,
                    active: false,
                    status: 1,
                    normalSpeed: null,
                    backoffSpeed: null,
                    backoff: false,
                    description: null
                },
                userList: null,
                groupList: null,
                serverList: null,
                socksList: null,
                statuses: RelayStatus.value,
                errors: {},
                showFailureMessage: false,
                submitting: false,
            }
        },
        mounted() {
            if (this.id) {
                SmtpRelayService.getRelay(this.id).then(response => {
                    this.relay = response.data;
                    this.$emit('hidePreloader', false);
                });
            }
        },
        validations() {
            if (!this.id) {
                return {
                    relay: {
                        group: {required},
                        smtpServer: {required},
                        account: {required},
                        password: {required},
                        senderEmail: {required, email},
                        description: {maxLength: maxLength(400)}
                    }
                }
            } else {
                return {
                    relay: {
                        group: {required},
                        smtpServer: {required},
                        account: {required},
                        password: {required},
                        senderEmail: {required, email},
                        normalSpeed: {required, integer},
                        backoffSpeed: {required, integer},
                        description: {maxLength: maxLength(400)}
                    }
                }
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (!this.relay.user) {
                    delete this.relay.user;
                }
                this.submitting = true;
                let submitMethod = null;

                if (this.id) {
                    submitMethod = SmtpRelayService.updateRelay(this.id, JSON.stringify(this.relay));
                } else {
                    submitMethod = SmtpRelayService.createRelay(JSON.stringify(this.relay));
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'smtpRelays'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                }).catch(error => {
                    this.submitting = false;
                    this.errors = error.response.data.error;
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadGroupList({callback}) {
                SmtpRelayGroupService.getGroupSelect().then(response => {
                    this.groupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback();
                });
            },
            loadServerList({callback}) {
                SmtpServerService.getServerSelect().then(response => {
                    this.serverList = response.data['hydra:member'].map(server => {
                        return {id: server.id, label: server.name}
                    });
                    callback();
                });
            },
            loadSocksList({callback}) {
                SocksProxyService.getSocksProxySelect().then(response => {
                    this.socksList = response.data['hydra:member'].map(socks => {
                        return {id: socks.id, label: socks.ip}
                    });
                    callback();
                });
            },
        }
    }
</script>

<style scoped>

</style>
